import Choices from 'choices.js'

export default class Accordion {
    constructor() {
        this.selectEls = document.querySelectorAll('select');

        this.selectEls.forEach((el) => {
            const choices = new Choices(el, {
                    itemSelectText: '',
                    flippedState: '',
                }
            );
        })

        this.removeNativeAutocomplete()
    }

    removeNativeAutocomplete() {
        const inputs = document.querySelectorAll('input.choices__input')
        inputs.forEach((el) => {
            el.setAttribute('autocomplete', 'no');
        });
    }
}